import { useState } from "react";
import PlannerSetup from "./PlannerSetup";
import { FileAnalysisResult } from "./FileAnalyser";
import PostPlanBuilder from "./PostPlanBuilder";
import { PostPlan } from "./PostPlanTypes";
import PostPlanBrowser from "./PostPlanBrowser";
import { USECASE_LABELS } from "./usecaseConfig";

export default function Planner() {
    const [files, setFiles] = useState<File[]>([]);
    const [analysedFiles, setAnalysedFiles] = useState<FileAnalysisResult[]>([]);
    const [selectedLanguage, setSelectedLanguage] = useState("english");
    const [selectedUseCases, setSelectedUseCases] = useState<string[]>([]);
    const [isPostGenerating, setIsPostGenerating] = useState(false);
    const [postGenerationStep, setPostGenerationStep] = useState("");
    const [mode, setMode] = useState<"new" | "browse">("new");
    const [selectedPlan, setSelectedPlan] = useState<PostPlan | null>(null);
    const [setupExpanded, setSetupExpanded] = useState(true);
    const [analysisDurationMs, setAnalysisDurationMs] = useState<number | null>(null);
    const [generationDurationMs, setGenerationDurationMs] = useState<number | null>(null);

    const handleGenerationDuration = (
  generationMs: number,
  generatedPostCount: number
) => {
  setGenerationDurationMs(generationMs);

  const analysisMs = analysisDurationMs ?? 0;

  const totalDurationMs =
    analysisMs + generationMs;

  const effectiveTimePerPostMs =
    generatedPostCount > 0
      ? totalDurationMs / generatedPostCount
      : 0;

  console.log("=== EVALUATION ===");

  console.table({
  analysisDurationMs: Math.round(analysisMs),
  generationDurationMs: Math.round(generationMs),
  totalDurationMs: Math.round(totalDurationMs),
  effectiveTimePerPostMs: Math.round(effectiveTimePerPostMs),
  generatedPostCount,
});
};

    const handleSelectUseCase = (usecase: string) => {
    if (selectedUseCases.includes(usecase)) {
      setSelectedUseCases(
        selectedUseCases.filter((uc) => uc !== usecase)
      );
    }else{
            setSelectedUseCases([...selectedUseCases, usecase]);
        }
    }

    const handleAnalysisComplete = (results: FileAnalysisResult[]) => {
        setAnalysedFiles(results);

        if (results.length > 0) {
            setSetupExpanded(false);
        }
    };


    return (
        
    <div className="planner-page">
        <div className="planner-setup-card">
            <div className="planner-page-header">
                <div>
                <h1>Planner</h1>
                <p>Erstelle oder lade einen Social-Media-Postplan.</p>
                </div>

                <div className="planner-header-actions">
                <div className="planner-mode-switch">
                    {/* Neuer Postplan / Postplan laden */}
                </div>

                <button
                    type="button"
                    className="planner-setup-toggle"
                    onClick={() => setSetupExpanded((current) => !current)}
                >
                    {setupExpanded ? "Einstellungen ausblenden ▲" : "Einstellungen anzeigen ▼"}
                </button>
                </div>
            </div>

            {setupExpanded ? (
                <PlannerSetup
                    files={files}
                    setFiles={setFiles}
                    selectedLanguage={selectedLanguage}
                    onLanguageChange={setSelectedLanguage}
                    selectedUseCases={selectedUseCases}
                    onUseCaseToggle={handleSelectUseCase}
                    onAnalysisComplete={handleAnalysisComplete}
                    isPostGenerating={isPostGenerating}
                    postGenerationStep={postGenerationStep}
                    onAnalysisDuration={setAnalysisDurationMs}
                />
            ) : (
                <div className="planner-setup-summary">
                    <div className="planner-setup-summary__channels">
                    {selectedUseCases.map((usecase) => (
                        <span
                        key={usecase}
                        className="planner-setup-summary__chip"
                        >
                        {USECASE_LABELS[usecase] ?? usecase}
                        </span>
                    ))}
                    </div>
                    <div className="planner-setup-summary__items">
                    <span>
                        {selectedLanguage === "german" ? "Deutsch" : "English"}
                    </span>

                    <span className="planner-setup-summary__separator">·</span>

                    <span>
                        {selectedUseCases.length === 0
                        ? "Keine Kanäle"
                        : `${selectedUseCases.length} ${
                            selectedUseCases.length === 1 ? "Kanal" : "Kanäle"
                            }`}
                    </span>

                    <span className="planner-setup-summary__separator">·</span>

                    <span>
                        {files.length} {files.length === 1 ? "Datei" : "Dateien"}
                    </span>
                    </div>

                    <button
                    type="button"
                    className="planner-setup-summary__edit"
                    onClick={() => setSetupExpanded(true)}
                    >
                    Ändern
                    </button>
                </div>
                )}
        </div>

      <div className="planner-mode-switch">
            <button
                type="button"
                className={mode === "new" ? "active" : ""}
                onClick={() => {
                    setMode("new");
                    setSelectedPlan(null);
                    setSetupExpanded(true);
                }}
            >
                Neuer Postplan
            </button>

            <button
                type="button"
                className={mode === "browse" ? "active" : ""}
                onClick={() => {
                    setMode("browse");
                    setSelectedPlan(null);
                    setSetupExpanded(false);
                }}
            >
                Postplan laden
            </button>
        </div>

      {mode === "browse" && !selectedPlan && (
        <PostPlanBrowser
          onSelectPlan={setSelectedPlan}
        />
      )}

      {(mode === "new" || selectedPlan) && (
        <PostPlanBuilder
          analysedFiles={
            mode === "new" ? analysedFiles : []
          }
          files={files}
          language={selectedLanguage}
          usecases={selectedUseCases}
          initialPlan={selectedPlan}
          onGeneratingChange={(generating, step) => {
            setIsPostGenerating(generating);
            setPostGenerationStep(step);
          }}
          onGenerationDuration={handleGenerationDuration}
        />
      )}
    </div>
  );
}